import { ExtendedContractTariff } from '../ExtendedContractTariff'
import { RuleType } from '../enumerations/rule-type'
import { RuleAction } from './rule-action'
import { RuleNotificationInterval } from '../enumerations'

export interface RuleDefinition {
	tariff                 : ExtendedContractTariff
	value                  : number
	deviceType             : string
	timeFrame              : number
	type                   : RuleType
	action                 : RuleAction
	notificationInterval   : RuleNotificationInterval
}